import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cn, numberFormatter } from "@/lib/utils";
import useWindowDimensions from "@/lib/web-ui/useWindowDimensions";
import { Button, Icon, Tag, Typography } from "@bookips/sds";
import Image from "next/image";
import Link from "next/link";
const MIN_REVIEW_RATING = 3;
const HandoutCard = (param)=>{
    let { title , imageUrl , price , avgReviewRating , authorName , brandName , unit , category , isCouponAvailable , onSampleClick , onCardClick , className  } = param;
    const { isMobile  } = useWindowDimensions();
    return /*#__PURE__*/ _jsxs("div", {
        className: cn("flex w-[224px] shrink-0 cursor-pointer flex-col gap-2.5 bg-white", "max-lg:w-[210px]", "max-sm:w-[150px] max-sm:min-w-[150px]", "max-sm:gap-2", className),
        onClick: onCardClick,
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "flex flex-col gap-2",
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: "bg-gray-0 flex h-[224px] flex-col justify-between rounded-md max-sm:h-[150px]",
                        children: [
                            /*#__PURE__*/ _jsx("div", {
                                className: "relative flex min-h-[184px] w-full flex-col items-center justify-center overflow-hidden p-2 max-sm:min-h-[150px]",
                                children: /*#__PURE__*/ _jsx("div", {
                                    className: "relative h-[130px] w-[92px] overflow-hidden rounded-sm max-sm:h-[96px] max-sm:w-[68px]",
                                    children: /*#__PURE__*/ _jsx(Image, {
                                        src: imageUrl || "/static/images/default-book-cover.png",
                                        alt: title,
                                        fill: true,
                                        className: "object-cover"
                                    })
                                })
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: "group/button w-full px-2 pb-2 max-sm:hidden",
                                children: /*#__PURE__*/ _jsx(Button, {
                                    variant: "stroke",
                                    color: "secondary",
                                    size: "sm",
                                    className: "h-8 w-full bg-white",
                                    onClick: (e)=>{
                                        e.stopPropagation();
                                        onSampleClick === null || onSampleClick === void 0 ? void 0 : onSampleClick();
                                    },
                                    children: "샘플 보기"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "flex flex-wrap items-center gap-1",
                        children: [
                            unit && /*#__PURE__*/ _jsx(Tag, {
                                color: "indigo",
                                bold: true,
                                size: isMobile ? "sm" : "md",
                                children: unit
                            }),
                            (category === null || category === void 0 ? void 0 : category.tag) && /*#__PURE__*/ _jsx(Tag, {
                                color: "gray",
                                size: isMobile ? "sm" : "md",
                                children: category === null || category === void 0 ? void 0 : category.tag
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "flex flex-col gap-1",
                        children: [
                            /*#__PURE__*/ _jsx(Typography, {
                                variant: "body1",
                                className: "text-primary max-sm:typo-body2 line-clamp-3",
                                children: title
                            }),
                            brandName ? /*#__PURE__*/ _jsx(Link, {
                                href: "/@".concat(brandName),
                                onClick: (e)=>e.stopPropagation(),
                                className: "w-fit [&:hover>*]:underline",
                                children: /*#__PURE__*/ _jsx(Typography, {
                                    variant: "body2",
                                    className: "text-secondary",
                                    children: authorName
                                })
                            }) : /*#__PURE__*/ _jsx(Typography, {
                                variant: "body2",
                                className: "text-secondary",
                                children: authorName
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "flex-col items-center",
                children: [
                    /*#__PURE__*/ _jsxs(Typography, {
                        variant: "h6",
                        className: "text-primary max-sm:typo-subtitle1 flex items-center gap-2",
                        children: [
                            "".concat(numberFormatter(price), "원"),
                            isCouponAvailable && /*#__PURE__*/ _jsx(Tag, {
                                color: "red",
                                size: "sm",
                                className: "typo-label",
                                children: "쿠폰"
                            })
                        ]
                    }),
                    avgReviewRating && Number(avgReviewRating) >= MIN_REVIEW_RATING && /*#__PURE__*/ _jsxs("div", {
                        className: "flex items-center gap-1",
                        children: [
                            /*#__PURE__*/ _jsx(Icon.StarIcon, {
                                size: "sm",
                                className: "text-yellow-300"
                            }),
                            /*#__PURE__*/ _jsx(Typography, {
                                variant: "caption",
                                className: "text-primary",
                                children: avgReviewRating
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
export default HandoutCard;
